<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g transform="translate(-10 -6)"><circle cx="2.5" cy="2.5" r="2.5" style="fill:#517dfb" transform="translate(13 9)"/><circle cx="2.5" cy="2.5" r="2.5" style="fill:#517dfb" transform="translate(21 14)"/><circle cx="2.5" cy="2.5" r="2.5" style="fill:#517dfb" transform="translate(13 19)"/><path d="m15.5 11.5 8.3 5.1-8.3 5.2" style="fill:none;stroke:#517dfb" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-widget-resource',
});
</script>
